import React from 'react';
import { Section } from './Section';
const contexts = [{
  title: 'Leyendo en la cama',
  description: 'Luz cálida sin molestar',
  media: 'https://cdn.magicpatterns.com/uploads/faUhVeJNT4vWgDTsVngbxn/0204d268-6da5-437f-b16c-981a9a71b68c.png',
  type: 'image'
}, {
  title: 'Control total',
  description: 'Indicador LED y modos de luz',
  media: 'https://cdn.magicpatterns.com/uploads/gwxQRvT8WUxPUUvBqwnHGS/电量显示2.mp4',
  type: 'video'
}, {
  title: 'Calidad superior',
  description: 'La diferencia se nota',
  media: 'https://cdn.magicpatterns.com/uploads/beD788pz8oBNswenbYrt1R/comparativa_luz_con_otros.png',
  type: 'image'
}, {
  title: 'Diseño adaptable',
  description: 'Brazo flexible 360°',
  media: 'https://cdn.magicpatterns.com/uploads/bBQBC4WR9JHGAHKWQc972o/567537fb-5394-4fc6-96ac-2182a2f0346c.png',
  type: 'image'
}];
export function Showcase() {
  return <Section data-id="element-172">
      <div className="mb-16 md:mb-20 text-center max-w-2xl mx-auto" data-id="element-173">
        <p className="text-sm font-medium text-[#FF6B1A] tracking-widest uppercase mb-4" data-id="element-174">
          Versatilidad total
        </p>
        <h2 className="text-3xl md:text-5xl font-light tracking-tight text-balance" data-id="element-175">
          Diseñada para cada momento
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-176">
        {contexts.map((ctx, i) => <div key={i} className="group relative rounded-2xl overflow-hidden aspect-[4/5] bg-[#0A0A0A]" data-id="element-177">
            {ctx.type === 'video' ? <video src={ctx.media} autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-90" data-id="element-178" /> : <img src={ctx.media} alt={ctx.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-90" data-id="element-179" />}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" data-id="element-180" />
            <div className="absolute bottom-0 left-0 p-6 w-full" data-id="element-181">
              <p className="text-white font-semibold text-lg tracking-tight" data-id="element-182">
                {ctx.title}
              </p>
              <p className="text-white/70 text-sm font-light mt-1" data-id="element-183">
                {ctx.description}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}